import { API_ENDPOINTS } from "@/api/services/pms/apiEndPoints";
import { baseApi } from "@/utils/baseApi";

export const EmployeeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addSelfAssessment: builder.mutation({
      query: ({ data, checkWeightage = 0 }) => {
        return {
          url: API_ENDPOINTS.PMS.ADD_SELF_ASSESSMENT(checkWeightage),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["pms_list"],
    }),
    getEmpPMSLetter: builder.query({
      query: (pmsYear) => {
        return {
          url: `${API_ENDPOINTS.PMS.FETCH_EMP_LETTER(pmsYear)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    getMyselfPmsYear: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.PMS.MYSELF_YEAR_DROPDOWN()}`,
          method: "GET",
        };
      },
      providesTags: ["Pms_Year"],
    }),
    getEmpLTIPLetter: builder.query({
      query: (pmsYear) => {
        return {
          url: `${API_ENDPOINTS.PMS.FETCH_EMP_LTIP_LETTER(pmsYear)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    getSelfAssessment: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.PMS.FETCH_EMP_DATA()}`,
          method: "GET",
        };
      },
      providesTags: ["self_assessment"],
    }),
    getEmpIfo: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.PMS.FETCH_EMP_INFO()}`,
          method: "GET",
        };
      },
      providesTags: ["self_assessment"],
    }),
    getWEmpLTIP: builder.query({
      query: ({ pmsYear, year }) => {
        return {
          url: `${API_ENDPOINTS.PMS.FETCH_LTIP(pmsYear, year)}`,
          method: "GET",
        };
      },
      providesTags: ["ltip"],
    }),
    getPMSDropdown: builder.query({
      query: ({ level, repManId, reviewerId, pmsYear, status, promotion,roleOfIntake  }) => {
        return {
          url: `${API_ENDPOINTS.PMS.PMS_DROPDOWN(level, repManId, reviewerId, pmsYear, status, promotion,roleOfIntake )}`,
          method: "GET",
        };
      },
      providesTags: ["pms_dropdown"],
    }),
    getPMSList: builder.query({
      query: ({
        level,
        repManId,
        reviewerId,
        empId,
        manPower,
        pmsYear,
        roleOfIntake,
        pageNo,
        pageSize,
        status,
        promotion,
      }) => {
        return {
          url: `${API_ENDPOINTS.PMS.PMS_LIST(level, repManId, reviewerId, empId, manPower, pmsYear, roleOfIntake, pageNo, pageSize, status, promotion)}`,
          method: "GET",
        };
      },
      providesTags: ["pms_list"],
    }),
    feedbackQuestions: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.PMS.FEEDBACK_QUESTION()}`,
          method: "GET",
        };
      },
      providesTags: ["pms_list"],
    }),
    pmsYearLtip: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.PMS.LTIP_PMSYEARS()}`,
          method: "GET",
        };
      },
      providesTags: ["pms_list"],
    }),
    getPMSAnalyticsChart: builder.query({
      query: ({ levelName, pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.PMS.PMS_ANALYTICS_CHART(levelName, pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["pms_analytics_chart"],
    }),
    getRepDivAnalyticsChart: builder.mutation({
      query: ({ levelName, pmsYear, repManId, reviewerId }) => {
        return {
          url: `${API_ENDPOINTS.PMS.PMS_REVIEWER_DIVISION_CHART(levelName, pmsYear, repManId, reviewerId)}`,
          method: "POST",
        };
      },
      providesTags: ["pms_analytics_chart"],
    }),
    editEmployeePms: builder.mutation({
      query: ({ data, checkWeightage = 0 }) => {
        return {
          url: API_ENDPOINTS.PMS.ADD_SELF_ASSESSMENT(checkWeightage),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["pms_list"],
    }),
    addFeedback: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.PMS.ADD_FEEDBACK(),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["pms_list"],
    }),
    employeeSummary: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_ENDPOINTS.PMS.EMPLOYEE_SUMMARY(),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["pms_list"],
    }),
    rmSummary: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_ENDPOINTS.PMS.RM_SUMMARY(),
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["pms_list"],
    }),
    getDhBudget: builder.query({
      query: ({ pmsYear, dhId, empId }) => {
        const params = new URLSearchParams();
        if (pmsYear) params.append("pmsYear", pmsYear);
        if (dhId) params.append("dhId", dhId);
        if (empId) params.append("empId", empId);
        return {
          url: `/pmsDHTargetMaster/getSelfList?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["DH_Budget"],
    }),
    getPmsBudgetCount: builder.query({
      query: ({
        pmsYear,
        divisionHeadId,
        reviewerId,
        repManagerId,
        status,
        promotion,
        empId,
      }) => {
        const body = {};
        if (pmsYear) body.pmsYear = pmsYear;
        if (divisionHeadId) body.divisionHeadId = divisionHeadId;
        if (reviewerId) body.reviewerId = reviewerId;
        if (repManagerId) body.repManagerId = repManagerId;
        if (status) body.status = status;
        if (promotion) body.promotion = promotion;
        if (empId) body.empId = empId;
        return {
          url: `/pms/getDHStatusCount`,
          method: "POST",
          body,
        };
      },
      providesTags: ["DH_Budget"],
    }),
  }),
});

export const {
  useAddSelfAssessmentMutation,
  useGetSelfAssessmentQuery,
  useGetEmpIfoQuery,
  useGetWEmpLTIPQuery,
  useLazyGetEmpPMSLetterQuery,
  useGetPMSDropdownQuery,
  useGetPMSListQuery,
  useFeedbackQuestionsQuery,
  useGetPMSAnalyticsChartQuery,
  useGetRepDivAnalyticsChartMutation,
  useLazyGetEmpLTIPLetterQuery,
  usePmsYearLtipQuery,
  useEditEmployeePmsMutation,
  useAddFeedbackMutation,
  useGetMyselfPmsYearQuery,
  useEmployeeSummaryMutation,
  useRmSummaryMutation,
  useGetDhBudgetQuery,
  useGetPmsBudgetCountQuery,
} = EmployeeApi;
